// src/components/eventos/hooks/useTarefaTempo.js
import { useState, useEffect } from 'react';

export const useTarefaTempo = (tarefa, tempoAtual) => {
    const calcularTempo = () => {
        const horaStr = tarefa.horaInicioReal || tarefa.horaInicio;
        if (!horaStr || !horaStr.includes(':')) {
            const duracao = (tarefa.duracao || 0) * 60;
            return { decorrido: 0, restante: duracao, duracao };
        }

        const agora = tempoAtual;
        const [h, m] = horaStr.split(':').map(Number);
        const inicio = new Date(agora);
        inicio.setHours(h, m, 0);

        const decorrido = Math.floor((agora - inicio) / 1000);
        const duracao = (tarefa.duracao || 0) * 60;
        const restante = duracao - decorrido;

        return { decorrido, restante, duracao };
    };

    return calcularTempo();
};

export const useTempoAtual = () => {
    const [tempoAtual, setTempoAtual] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTempoAtual(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return tempoAtual;
};
